import { useNavigate } from 'react-router-dom';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
// import MDAlert from "components/MDAlert";
import MDButton from 'components/MDButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Select from 'react-select';
import { Oval } from 'react-loader-spinner';
import * as service from '../../services/service';

function Event() {
    const [categoryId, setCategoryId] = useState('');
    const [categoryData, setCategoryData] = useState([]);
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };

    const getEventCategories = () => {
        fetch(
            service.GET_EVENT_CATEGORY,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                }
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.eventCategoryId, label: item.eventCategory }));
                setCategoryData(data2);
            })
            .catch(err => {
                if (err) {
                    setError(err);
                };
            });
    };

    const getDetails = (id) => {
        fetch(
            service.GET_EVENT_BY_CATEGORY_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: JSON.stringify({
                    EventCategoryId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                setData(result);
                if (result.length === 0) {
                    setError('No Data Found');
                }
            })
            .catch(err => {
                if (err) {
                    setError(err);
                };
            });
    };

    const handleEdit = (id) => {
        navigate(`/addeditevent/${id}`);
    }

    const handleQuotations = (id, evName, catName, evExe, expHead) => {
        localStorage.setItem('eventname', JSON.stringify(evName));
        localStorage.setItem('categoryname', JSON.stringify(catName));
        localStorage.setItem('eventexecution', JSON.stringify(evExe));
        localStorage.setItem('expensehead', JSON.stringify(expHead));
        navigate(`/addeditquotations/${id}`);
    }

    useEffect(() => {
        setLoading(true);
        getEventCategories();
        localStorage.setItem('eventname', null);
        localStorage.setItem('categoryname', null);
        setLoading(false);
    }, []);

    const categoryChangeHandler = (ev) => {
        setCategoryId(ev);
        getDetails(ev.value)
    }

    const addNew = () => {
        navigate('/addeditevent/0');
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div style={{ float: 'right' }}>
                <MDButton color="info" onClick={addNew}>
                    ADD NEW
                </MDButton>
            </div>
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Event Details
                                </MDTypography>
                            </MDBox>
                            <br />
                            <MDBox mx={50}
                                mt={-3}
                                py={3}
                                px={2}>
                                <Table>
                                    <TableRow>
                                        <TableCell>
                                            <MDBox style={{ fontSize: '14px' }}>
                                                <Select
                                                    options={categoryData}
                                                    name="eventCategoryId"
                                                    value={categoryId}
                                                    onChange={categoryChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    placeholder="Select Event Category"
                                                />
                                                {/* <div style={{ fontSize: '12px', color: 'red' }}>{error[".state"]}</div> */}
                                            </MDBox>
                                        </TableCell>
                                    </TableRow>
                                </Table>
                            </MDBox>
                            <br />
                            {error
                                ? <div style={{ color: 'red', fontSize: '14px', alignSelf: 'center' }}>{error}</div>
                                : null
                            }
                            <Card style={{ alignItems: 'center' }}>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '90%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">
                                            <TableRow style={{ backgroundColor: 'lightsalmon' }}>
                                                <TableCell style={{ fontWeight: 'bold' }}>Event Name</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Annual Budget</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Expense Head</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Accounting Year</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Event Execution</TableCell>
                                                <TableCell colSpan="2" align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>
                                            </TableRow>
                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow
                                                        key={row.eventId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell component="th" scope="row">{row.eventName}</TableCell>
                                                        <TableCell component="th" scope="row">{row.annualBudget}</TableCell>
                                                        <TableCell component="th" scope="row">{row.expenseHead}</TableCell>
                                                        <TableCell component="th" scope="row">{row.accountingYear}</TableCell>
                                                        <TableCell component="th" scope="row">{row.eventExecution}</TableCell>
                                                        <TableCell><MDButton onClick={() => handleEdit(row.eventId)}>Edit</MDButton></TableCell>
                                                        {row.eventExecution === 'Quotation' ? <TableCell><MDButton onClick={() => handleQuotations(row.eventId, row.eventName, categoryId.label, row.eventExecution, row.expenseHead)}>Quotations</MDButton></TableCell> : null}
                                                        {row.eventExecution === 'Open Tender' ? <TableCell><MDButton onClick={() => handleQuotations(row.eventId, row.eventName, categoryId.label, row.eventExecution, row.expenseHead)}>Open Tender</MDButton></TableCell> : null}
                                                        {row.eventExecution === 'Closed Tender' ? <TableCell><MDButton onClick={() => handleQuotations(row.eventId, row.eventName, categoryId.label, row.eventExecution, row.expenseHead)}>Closed Tender</MDButton></TableCell> : null}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default Event;